import {Grid} from "@mui/system";
import style from "../../../assets/css/proposal.module.scss";
import {Link, useNavigate} from "react-router-dom";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Button,
  Breadcrumbs,
  Typography,
} from "@mui/material";
import {useCallback, useEffect, useMemo, useRef, useState} from "react";
import {HiCurrencyDollar, HiOutlineClock} from "react-icons/hi2";
import {useDispatch, useSelector} from "react-redux";
import {selectAuthState, setAuthData} from "../../../store/authSlice";
import {selectDataStoreState, setDataStore} from "../../../store/dataSlice";
import {selectUiState, setUiData} from "../../../store/uiSlice";
import {
  AGENT_CLIENTS,
  AGENT_SUBMITTED_PROPOSALS,
  DOCUSIGN_PREPARE,
  SUBMITTED_PROPOSALS,
} from "../../../constants/apiConstant";
import {removeCookies} from "../../../constants/helper";
import GlobalNotificationPopup from "../../global-fields/GlobalNotificationPopup";
import {SiAdobeacrobatreader} from "react-icons/si";
import PaymentModal from "../../payment-modal";
import NoDataComponent from "../../no-data";
import {BsExclamationSquare} from "react-icons/bs";
import {BsCheckSquare} from "react-icons/bs";
import {AiOutlineSignature} from "react-icons/ai";
import GlobalModal from "../../global-fields/GlobalModal";
import DocuSignModal from "../../docusign-modal/DocuSignModal";
import {
  fetchDocumentAsBase64,
  initiateSigning,
} from "../../../constants/docusignService";
import {MdModeEdit} from "react-icons/md";

const columns = [
  {id: "id", label: "#", minWidth: 25},
  {id: "proposal_id", label: "Proposal Number", minWidth: 150},
  {id: "proposal_date", label: "Proposal Date", minWidth: 170},
  {id: "updated_at", label: "Last Update Date", minWidth: 170},
  {id: "formated_soft_quote", label: "Soft Quote Amt", minWidth: 110},
  {id: "formated_hard_quote", label: "Hard Quote Amt", minWidth: 100},
  {id: "pdf", label: "Proposal", minWidth: 90},
  {id: "esign", label: "e-Sign", minWidth: 80},
  {id: "payment_status", label: "Payment", minWidth: 80},
];
const agentColumns = [
  {id: "id", label: "#", minWidth: 25},
  {id: "full_name", label: "Client Name", minWidth: 150},
  {id: "proposal_id", label: "Proposal Number", minWidth: 150},
  {id: "proposal_date", label: "Proposal Date", minWidth: 170},
  {id: "updated_at", label: "Last Update Date", minWidth: 170},
  {id: "formated_soft_quote", label: "Soft Quote Amt", minWidth: 110},
  {id: "formated_hard_quote", label: "Hard Quote Amt", minWidth: 100},
  {id: "pdf", label: "Proposal", minWidth: 90},
  {id: "esign", label: "e-Sign", minWidth: 80},
  {id: "payment_status", label: "Payment", minWidth: 80},
];

const rows = Array.from({length: 9}, (_, index) => ({
  id: index + 1,
  proposal_id: `PROP010120XX-${index + 1}`,
  proposal_date: "01/01/20XX XX:XX AM",
  formated_soft_quote: "$253454.34",
  formated_hard_quote: 0,
  hard_quote: 0,
  soft_quote: "253454.34",
  pdf: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
  payment_status: 0,
}));

const SubmittedProposal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isFirstRender = useRef(true);
  const {user} = useSelector(selectAuthState);
  const {showLoader, eSignModal} = useSelector(selectUiState);
  const {submittedProposalsData, submittedProposalsCount} =
    useSelector(selectDataStoreState);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  // const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
  // const [currentRow, setCurrentRow] = useState(null);

  const [signingUrl, setSigningUrl] = useState(null);

  const submittedPropList = useMemo(
    () => (submittedProposalsData?.length ? submittedProposalsData : []),
    [submittedProposalsData]
  );
  //const submittedPropList = submittedProposalsData || [];

  //console.log("submittedPropList", submittedProposalsData, submittedPropList);

  const fetchSubmittedPro = useCallback(async () => {
    if (page === null || rowsPerPage === null) {
      return;
    }
    dispatch(setUiData({showLoader: true}));

    let data = {
      limit: rowsPerPage,
      offset: page * rowsPerPage,
    };

    let apiDetails =
      user?.user_type === "agent"
        ? {
            method: AGENT_SUBMITTED_PROPOSALS.method,
            headers: AGENT_SUBMITTED_PROPOSALS.headers,
            url: AGENT_SUBMITTED_PROPOSALS.url,
          }
        : {
            method: SUBMITTED_PROPOSALS.method,
            headers: SUBMITTED_PROPOSALS.headers,
            url: SUBMITTED_PROPOSALS.url,
          };

    data[user?.user_type === "agent" ? "agent_id" : "user_id"] = user?.id;

    const options = {
      method: apiDetails.method,
      headers: apiDetails.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(apiDetails.url, options);
      const res = await response.json();
      if (res.status == 1) {
        dispatch(
          setDataStore({
            submittedProposalsData: res?.proposal_list || [],
            submittedProposalsCount: res?.total_count || 0,
          })
        );
      } else {
        console.error("Error fetching proposals");
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error});
      navigate("/");
    } finally {
      dispatch(setUiData({showLoader: false}));
    }
  }, [page, rowsPerPage, user]);

  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false; // Prevent the second fetch caused by Strict Mode
    //   return;
    // }
    fetchSubmittedPro();
  }, [fetchSubmittedPro, page, rowsPerPage]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  // const setRowsPerPageFn = (dt) => {
  //   setRowsPerPage(dt);
  //   setPage(0);
  // };

  const handlePDF = (row) => {
    // console.log("Downloading PDF:", row?.proposal_pdf);
    if (!row?.proposal_pdf) {
      console.error("Invalid PDF URL");
      return;
    }
    window.open(row?.proposal_pdf, "_blank");
    // window.open("https://suryaapi.demobw.com/pdf/proposal_188.pdf", "_blank");
  };

  const handlePayment = async (row) => {
    if (row?.is_proposal_signed != 1) {
      GlobalNotificationPopup({
        type: "error",
        message:
          "Digital signature required: Please complete the signing process first.",
      });
      return;
    }

    dispatch(
      setDataStore({
        checkoutData: {
          proposal_id: row?.proposal_id,
          // amount: row?.hard_quote,
          formated_hard_quote: row?.formated_hard_quote,
          formated_hard_quote_with_Fee: row?.formated_hard_quote_with_Fee,
          proposal_date: row?.proposal_date,
          firm_name: row.firm_name,
        },
        checkoutRawData: row,
      })
    );
    navigate("/checkout");
  };
  const handleEsign = (row) => {
    dispatch(setUiData({eSignModal: row}));
    dispatch(setDataStore({docusignData: row}));
    initiateSigning(row);
    // navigate("/docusign-initiate");
  };

  const initiateSigning = async (rowdata) => {
    dispatch(setUiData({showLoader: true}));
    dispatch(setDataStore({docusignURL: null}));
    // setLoading(true);
    // setError(null);

    const data = {
      proposal_id: rowdata?.proposal_id,
      signer_email: rowdata?.email,
      signer_name: rowdata?.full_name,
      document_path: rowdata?.proposal_pdf,
    };

    const options = {
      method: DOCUSIGN_PREPARE.method,
      headers: DOCUSIGN_PREPARE.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(DOCUSIGN_PREPARE.url, options);
      const res = await response.json();

      if (res.success && res.signing_url) {
        dispatch(setDataStore({docusignURL: res.signing_url}));

        const width = 850;
        const height = 700;
        const left = window.screen.width / 2 - width / 2;
        const top = window.screen.height / 2 - height / 2;
        const authWindow = window.open(
          res.signing_url,
          "_blank",
          `width=${width},height=${height},top=${top},left=${left}`
        );

        if (
          !authWindow ||
          authWindow.closed ||
          typeof authWindow.closed === "undefined"
        ) {
          GlobalNotificationPopup({
            type: "error",
            message:
              'Popup blocked! Please allow popups for this site, then click "Sign Your Proposal" again.',
          });
        }

        const interval = setInterval(() => {
          if (authWindow.closed) {
            clearInterval(interval);
            dispatch(setDataStore({docusignData: null, docusignURL: null}));
            fetchSubmittedPro();
            // console.log("DocuSign window closed");
          }
        }, 500);
      } else {
        console.error(
          "Failed to prepare the signing process. Please try again."
        );
      }
    } catch (err) {
      // setError("Failed to complete signing process");
      console.error(err);
    } finally {
      // setLoading(false);
      dispatch(setUiData({showLoader: false}));
    }
  };

  // const hasInitiatedSigning = useRef(false);

  // useEffect(() => {
  //   if (!docusignData && !docusignURL) {
  //     //initiateSigning();
  //     // hasInitiatedSigning.current = true; // Mark as called
  //     // handleSignDocument(docusignData)

  //     navigate("/submitted-proposal");
  //   }
  // }, [docusignData, docusignURL]);

  const renderPaymentStatus = (row) => {
    if (row.hard_quote == 0) return <span style={{color: "#FF2116"}}>N/A</span>;
    if (row.is_proposal_signed == 0)
      return <span style={{color: "#FF2116"}}>N/A</span>;

    switch (row.payment_status) {
      case 1:
        return <BsCheckSquare color="#00BA34" size={24} />;
      default:
        return (
          <Button
            onClick={() => handlePayment(row)}
            variant="contained"
            color="primary"
            size="small"
            style={{
              marginRight: 8,
              background: row.hard_quote == 0 ? "#f1f1f1" : "#004F71",
            }}
            disabled={row.hard_quote == 0}
          >
            <HiCurrencyDollar />
            Pay
          </Button>
        );
    }
  };

  const renderEsignStatus = (row) => {
    if (row.hard_quote == 0 || !row?.proposal_pdf)
      return <span style={{color: "#FF2116"}}>N/A</span>;
    if (row?.is_proposal_signed == 1)
      return <BsCheckSquare color="#00BA34" size={24} />;
    return (
      <AiOutlineSignature
        onClick={() => handleEsign(row)}
        style={{cursor: "pointer"}}
        color="#353434"
        size={24}
      />
    );
  };
  const renderPaymentStatusAgent = (row) => {
    if (row.hard_quote == 0) return <span style={{color: "#FF2116"}}>N/A</span>;
    if (row.is_proposal_signed == 0)
      return <span style={{color: "#FF2116"}}>N/A</span>;
    switch (row.payment_status) {
      case 0:
        return <HiOutlineClock color="#ff8607" size={28} />;
      case 1:
        return <BsCheckSquare color="#00BA34" size={24} />;
      case 2:
        return <BsExclamationSquare color="#FF2116" size={24} />;
      default:
        return <span style={{color: "#FF2116"}}>N/A</span>;
    }
  };

  const renderEsignStatusAgent = (row) => {
    if (row.hard_quote == 0 || !row?.proposal_pdf)
      return <span style={{color: "#FF2116"}}>N/A</span>;
    if (row?.is_proposal_signed == 1)
      return <BsCheckSquare color="#00BA34" size={24} />;
    return <HiOutlineClock color="#ff8607" size={28} />;
  };
  const clientSearch = async (searchTerm,company_name,user_id) => {
    if (page === null || rowsPerPage === null) return;

    dispatch(setUiData({showLoader: true}));

    const data = {
      agent_id: user?.id,
      limit: 10,
      offset: 0,
      search: searchTerm,
      company : company_name,
      user_id:user_id

    };

    const options = {
      method: AGENT_CLIENTS.method,
      headers: AGENT_CLIENTS.headers,
      body: JSON.stringify(data),
    };

    try {
      const response = await fetch(AGENT_CLIENTS.url, options);
      const res = await response.json();

      dispatch(setUiData({showLoader: false}));

      if (res.status == 1) {
        return res?.user_list?.[0] ?? null;
      } else {
        GlobalNotificationPopup({type: "error", message: res?.message});
        return null;
      }
    } catch (error) {
      removeCookies("isLogin");
      GlobalNotificationPopup({type: "error", message: error});
      console.error("Error:", error);
      dispatch(setUiData({showLoader: false}));
      navigate("/");
      return null;
    }
  };

  const handleEdit = async (row) => {
    if (user?.user_type === "agent") {
      const client_ = await clientSearch(row.full_name,row.firm_name,row.user_id);
      if (client_) {
        dispatch(setAuthData({selectedClient: client_}));
      } else {
        GlobalNotificationPopup({
          type: "error",
          message: "Client Details Not Found!",
        });
        return;
      }
    }
    // console.log("ROWWWW",row)
    // return;
    dispatch(
      setDataStore({
        proposalStep: 1,
        proposal_id: row.proposal_id,
        editingSubmitted: true,
      })
    );

    navigate("/new-proposal");
  };

  const columns = [
    {
      id: "serial",
      label: "#",
      minWidth: 25,
      renderCell: (_row, index) => page * rowsPerPage + index + 1,
    },
    {
      id: "proposal_id",
      label: "Proposal Number",
      minWidth: 150,
    },
    {
      id: "full_name",
      label: "Client Name",
      minWidth: 150,
    },
    {
      id: "proposal_date",
      label: "Proposal Date",
      minWidth: 170,
    },
    {
      id: "updated_at",
      label: "Last Updated Date",
      minWidth: 170,
    },
    {
      id: "formated_soft_quote",
      label: "Soft Quote Amt",
      minWidth: 110,
    },
    {
      id: "formated_hard_quote",
      label: "Hard Quote Amt",
      minWidth: 100,
    },
    {
      id: "pdf",
      label: "Proposal",
      minWidth: 90,
      renderCell: (row) => (
        <Button
          onClick={() => handlePDF(row)}
          variant="contained"
          color="primary"
          size="small"
          style={{
            marginRight: 8,
            background: "#F5F5F5",
            color: "#2C2C2C",
            //  borderRadius: "5px 5px 5px 5px",
            border: "1px solid rgba(0, 0, 0, 0.11)",
          }}
        >
          <SiAdobeacrobatreader
            style={{marginRight: "7px", fontSize: "18px"}}
            color="#FF2116"
          />
          PDF
        </Button>
      ),
    },
    {
      id: "esign",
      label: "e-Sign",
      minWidth: 80,
      renderCell: (row) => renderEsignStatus(row),
    },
    {
      id: "payment_status",
      label: "Payment",
      minWidth: 80,
      renderCell: (row) => renderPaymentStatus(row),
    },
    {
      id: "action",
      label: "Action",
      minWidth: 80,
      renderCell: (row) => (
        <>
          <Button
            onClick={() => handleEdit(row)}
            variant="contained"
            color="primary"
            size="small"
            style={{
              marginRight: 8,
              background: row.payment_status == 1 ? "#f1f1f1" : "#004F71",
            }}
            disabled={row.payment_status == 1}
          >
            <MdModeEdit /> Edit
          </Button>
          {/* <Button
                onClick={() => handleDelete(row)}
                variant="contained"
                sx={{background: "#004f71"}}
                size="small"
              >
                <MdDelete /> Delete
              </Button> */}
        </>
      ),
    },
  ];

  const agentColumns = [
    {
      id: "serial",
      label: "#",
      minWidth: 25,
      renderCell: (_row, index) => page * rowsPerPage + index + 1,
    },
     {
    id: "full_name",
      label: "Client Name",
      minWidth: 150,
    },
    {
      id: "firm_name",
      label: "Company Name",
      minWidth: 150,
    },
    {
      id: "proposal_id",
      label: "Proposal Number",
      minWidth: 150,
    },
    {
      id: "proposal_date",
      label: "Proposal Date",
      minWidth: 170,
    },
    {
      id: "updated_at",
      label: "Last Updated Date",
      minWidth: 170,
    },
    {
      id: "formated_soft_quote",
      label: "Soft Quote Amt",
      minWidth: 110,
    },
    {
      id: "formated_hard_quote",
      label: "Hard Quote Amt",
      minWidth: 100,
    },
    {
      id: "pdf",
      label: "Proposal",
      minWidth: 90,
      renderCell: (row) => (
        <Button
          onClick={() => handlePDF(row)}
          variant="contained"
          color="primary"
          size="small"
          style={{
            marginRight: 8,
            background: "#F5F5F5",
            color: "#2C2C2C",
            //  borderRadius: "5px 5px 5px 5px",
            border: "1px solid rgba(0, 0, 0, 0.11)",
          }}
        >
          <SiAdobeacrobatreader
            style={{marginRight: "7px", fontSize: "18px"}}
            color="#FF2116"
          />
          PDF
        </Button>
      ),
    },
    {
      id: "esign",
      label: "e-Sign",
      minWidth: 80,
      renderCell: (row) => renderEsignStatusAgent(row),
    },
    {
      id: "payment_status",
      label: "Payment",
      minWidth: 80,
      renderCell: (row) => renderPaymentStatusAgent(row),
    },
    {
      id: "action",
      label: "Action",
      minWidth: 80,
      renderCell: (row) => (
        <>
          <Button
            onClick={() => handleEdit(row)}
            variant="contained"
            color="primary"
            size="small"
            style={{
              marginRight: 8,
              background: row.payment_status == 1 ? "#f1f1f1" : "#004F71",
            }}
            disabled={row.payment_status == 1}
          >
            <MdModeEdit /> Edit
          </Button>
          {/* <Button
                onClick={() => handleDelete(row)}
                variant="contained"
                sx={{background: "#004f71"}}
                size="small"
              >
                <MdDelete /> Delete
              </Button> */}
        </>
      ),
    },
  ];

  useEffect(() => {
    const paginationInputs = document.querySelectorAll(
      ".MuiSelect-nativeInput"
    );
    paginationInputs.forEach((input, index) => {
      // Add aria-label only if not already present
      if (!input.hasAttribute("aria-label")) {
        input.setAttribute("aria-label", `Page number input ${index + 1}`);
      }
    });
  }, []);

  // console.log("submittedPropList", submittedPropList);

  return (
    <>
      <Grid
        container
        spacing={3}
        className="customeContainer"
        justifyContent="center"
      >
        <Grid size={{xs: 12, lg: 12}} sx={{mt: 2}}>
          <div className={style.propPagination}>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" to="/dashboard">
                Dashboard
              </Link>

              <Typography sx={{color: "text.primary"}}>
                Submitted Proposals
              </Typography>
            </Breadcrumbs>
          </div>
        </Grid>
      </Grid>

      <section className={style.ProposalUnderProgessSection}>
        <Grid
          container
          spacing={3}
          className="customeContainer"
          justifyContent="center"
        >
          <Grid size={{xs: 12, lg: 12}}>
            <div className={style.propUnderProgTitle}>
              <h3>Submitted Proposals</h3>
              <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                component="div"
                count={submittedProposalsCount || 0} // Use correct count
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                disabled={submittedPropList?.length <= 0}
              />
            </div>

            <Paper className={style.propTableMain}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      {(user?.user_type === "agent"
                        ? agentColumns
                        : columns
                      ).map((column) => (
                        <TableCell
                          style={{minWidth: column.minWidth}}
                          key={column.id}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {/* {submittedPropList?.length > 0 ? (
                    <TableBody>
                      {submittedPropList.map((row, idx) => (
                        <TableRow key={row.id + row.proposal_date}>
                          <TableCell>
                            {page * rowsPerPage + (idx + 1)}
                          </TableCell>
                          {user?.user_type === "agent" ? (
                            <TableCell>{row.full_name}</TableCell>
                          ) : null}
                          <TableCell>{row.proposal_id}</TableCell>
                          <TableCell>{row.proposal_date}</TableCell>
                          <TableCell>
                            <span
                            >
                              {row.formated_soft_quote == "0.00"
                                ? "N/A"
                                : row.formated_soft_quote}
                            </span>
                          </TableCell>
                          <TableCell>
                            <span
                            >
                              {row.formated_hard_quote == 0
                                ? "N/A"
                                : row.formated_hard_quote}
                            </span>
                          </TableCell>
                          <TableCell>
                            {!row?.proposal_pdf ? (
                              <span
                                style={{
                                  color: "#FF2116",
                                }}
                              >
                                N/A
                              </span>
                            ) : (
                              <Button
                                onClick={() => handlePDF(row)}
                                variant="contained"
                                color="primary"
                                size="small"
                                style={{
                                  marginRight: 8,
                                  background: "#F5F5F5",
                                  color: "#2C2C2C",
                                  border: "1px solid rgba(0, 0, 0, 0.11)",
                                }}
                              >
                                <SiAdobeacrobatreader
                                  style={{marginRight: "7px", fontSize: "18px"}}
                                  color="#FF2116"
                                />
                                PDF
                              </Button>
                            )}
                          </TableCell>
                          {user?.user_type === "agent" ? (
                            <>
                              <TableCell>
                                {renderEsignStatusAgent(row)}
                              </TableCell>
                              <TableCell>
                                {renderPaymentStatusAgent(row)}
                              </TableCell>
                            </>
                          ) : (
                            <>
                              <TableCell>{renderEsignStatus(row)}</TableCell>
                              <TableCell>{renderPaymentStatus(row)}</TableCell>
                            </>
                          )}

                         
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : null} */}

                  {submittedPropList?.length > 0 ? (
                    <TableBody>
                      {submittedPropList.map((row, idx) => (
                        <TableRow key={row.proposal_id}>
                          {(user?.user_type === "agent"
                            ? agentColumns
                            : columns
                          ).map((column) => (
                            <TableCell key={column.id}>
                              {column.renderCell
                                ? column.renderCell(row, idx)
                                : row[column.id]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  ) : null}
                </Table>
                {submittedPropList?.length > 0
                  ? null
                  : !showLoader && <NoDataComponent />}
              </TableContainer>
            </Paper>
          </Grid>
        </Grid>
      </section>
      <PaymentModal
        fetchSubmittedPro={() => {
          fetchSubmittedPro();
        }}
      />
    </>
  );
};

export default SubmittedProposal;
